import { Controller } from "@hotwired/stimulus"

const CONSENT_SCRIPT_URL = "https://www.termsfeed.com/public/cookie-consent/4.2.0/cookie-consent.js"

export default class extends Controller {
  static values = {
    gaId: String,
    websiteName: String,
    privacyUrl: String,
  }

  connect() {
    this._loadScript()
  }

  _loadScript() {
    if (document.querySelector(`script[src="${CONSENT_SCRIPT_URL}"]`)) {
      if (typeof cookieconsent !== "undefined") this._initBanner()
      return
    }
    const script = document.createElement("script")
    script.src = CONSENT_SCRIPT_URL
    script.charset = "UTF-8"
    script.defer = true
    script.onload = () => this._initBanner()
    document.head.appendChild(script)
  }

  _initBanner() {
    if (typeof cookieconsent === "undefined") return
    if (window.__cookieConsentInitialized) return
    window.__cookieConsentInitialized = true

    cookieconsent.run({
      notice_banner_type: "simple",
      consent_type: "express",
      palette: "dark",
      language: "pl",
      page_load_consent_levels: ["strictly-necessary"],
      notice_banner_reject_button_hide: false,
      preferences_center_close_button_hide: false,
      page_refresh_confirmation_buttons: false,
      website_name: this.websiteNameValue,
      website_privacy_policy_url: this.privacyUrlValue,

      // callbacks_force: true – callback odpala się też gdy użytkownik już wcześniej wyraził zgodę
      callbacks_force: true,
      callbacks: {
        scripts_specific_loaded: (level) => {
          if (level !== "strictly-necessary" && !window.__youtubeConsentGranted) {
            window.__youtubeConsentGranted = true
            window.dispatchEvent(new Event("youtube:consent-granted"))
          }
          if (level === "targeting" || level === "tracking") {
            this._grantGAConsent()
          }
        },
      },
    })
  }

  _grantGAConsent() {
    if (typeof gtag === "undefined") return

    gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    })

    if (this.gaIdValue) {
      gtag("config", this.gaIdValue)
    }
  }
}
